import { createBrowserHistory } from 'history';
import { IsSchoolUiDecoupledEnabled } from 'utility/constants';



export default createBrowserHistory({ basename:  IsSchoolUiDecoupledEnabled() ? "/school_ui" : "" });
